import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PolitiqueConfidentialite() {
  return (
    <div className="bg-[#FAFAFA] text-[#1A1918] min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-28 md:pt-36 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#C86641]">◆ Vos données</div>
          <h1 className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95] mt-6" data-testid="confidentialite-title">
            Politique de confidentialité.
          </h1>
          <p className="mt-4 text-[#5C5A56]">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>

          <div className="mt-12 space-y-10 text-[15px] leading-relaxed text-[#1A1918]">
            <Section title="Introduction">
              <p>
                E-PRO.Intervention attache une grande importance à la protection de vos données personnelles.
                La présente politique de confidentialité a pour objet de vous informer sur la manière dont vos données
                sont collectées, utilisées, conservées et protégées, conformément au Règlement Général sur la Protection
                des Données (Règlement UE 2016/679, dit « RGPD ») et à la loi française « Informatique et Libertés ».
              </p>
            </Section>

            <Section title="1. Responsable du traitement">
              <p>
                Le responsable du traitement des données personnelles est <strong>E-PRO.Intervention</strong>,
                micro-entreprise dont les coordonnées sont indiquées dans les <a href="/mentions-legales" className="text-[#C86641] underline">mentions légales</a>.
                Pour toute question relative à vos données, vous pouvez nous contacter par email
                à <a href="mailto:valdoise-95@hotmail.com" className="text-[#C86641]">valdoise-95@hotmail.com</a>.
              </p>
            </Section>

            <Section title="2. Données collectées">
              <p>Nous collectons uniquement les données strictement nécessaires aux finalités décrites ci-dessous :</p>
              <ul className="mt-3 space-y-2 list-disc list-inside">
                <li><strong>Lors d'une demande de devis :</strong> nom, prénom, email, téléphone, ville, type de projet et description du chantier.</li>
                <li><strong>Lors de la création d'un compte client :</strong> nom, email, téléphone (optionnel) et mot de passe (chiffré).</li>
                <li><strong>Lors d'un échange par messagerie :</strong> contenu des messages que vous nous adressez.</li>
                <li><strong>Données techniques :</strong> cookies de session strictement nécessaires au fonctionnement du site (authentification).</li>
              </ul>
            </Section>

            <Section title="3. Finalités du traitement">
              <p>Vos données sont collectées et traitées pour les finalités suivantes :</p>
              <ul className="mt-3 space-y-2 list-disc list-inside">
                <li>Répondre à vos demandes de devis et établir des estimations chiffrées ;</li>
                <li>Vous contacter dans le cadre de la relation commerciale (téléphone, email, messagerie) ;</li>
                <li>Gérer votre compte client et l'historique de vos demandes ;</li>
                <li>Améliorer la qualité de nos services (avis clients, statistiques internes).</li>
              </ul>
              <p className="mt-3">
                <strong>Base légale :</strong> exécution de mesures précontractuelles à votre demande (art. 6.1.b RGPD)
                et intérêt légitime pour la gestion de la relation commerciale (art. 6.1.f RGPD).
              </p>
            </Section>

            <Section title="4. Destinataires des données">
              <p>
                Vos données sont strictement réservées à E-PRO.Intervention et ne sont en aucun cas vendues, louées ou
                cédées à des tiers à des fins commerciales.
              </p>
              <p>
                Les seuls sous-traitants techniques susceptibles d'avoir accès à vos données sont :
              </p>
              <ul className="mt-3 space-y-2 list-disc list-inside">
                <li><strong>Notre hébergeur</strong> (plateforme Emergent), pour le stockage technique des données ;</li>
                <li><strong>Notre prestataire d'envoi d'emails</strong> (Resend), uniquement pour transmettre les notifications
                  de demande de devis à l'administrateur.</li>
              </ul>
              <p>Ces prestataires sont tenus par contrat à la confidentialité et au respect du RGPD.</p>
            </Section>

            <Section title="5. Durée de conservation">
              <ul className="mt-3 space-y-2 list-disc list-inside">
                <li><strong>Demandes de devis :</strong> 3 ans à compter du dernier contact (prospection commerciale).</li>
                <li><strong>Comptes clients :</strong> tant que le compte est actif. Supprimé à votre demande.</li>
                <li><strong>Messages de la messagerie :</strong> conservés tant que le compte client est actif.</li>
                <li><strong>Données comptables et factures :</strong> 10 ans (obligation légale, art. L.123-22 du Code de commerce).</li>
              </ul>
            </Section>

            <Section title="6. Vos droits">
              <p>Conformément au RGPD, vous disposez à tout moment des droits suivants :</p>
              <ul className="mt-3 space-y-2 list-disc list-inside">
                <li><strong>Droit d'accès</strong> à vos données ;</li>
                <li><strong>Droit de rectification</strong> des données inexactes ;</li>
                <li><strong>Droit à l'effacement</strong> (« droit à l'oubli ») ;</li>
                <li><strong>Droit à la limitation</strong> du traitement ;</li>
                <li><strong>Droit à la portabilité</strong> de vos données ;</li>
                <li><strong>Droit d'opposition</strong> au traitement, notamment à des fins de prospection commerciale.</li>
              </ul>
              <p className="mt-3">
                Pour exercer ces droits, contactez-nous par email à
                <a href="mailto:valdoise-95@hotmail.com" className="text-[#C86641]"> valdoise-95@hotmail.com</a> en précisant votre demande.
                Une réponse vous sera apportée sous un délai maximum d'un mois.
              </p>
              <p>
                En cas de difficulté, vous pouvez également déposer une réclamation auprès de la
                <a href="https://www.cnil.fr/" target="_blank" rel="noopener noreferrer" className="text-[#C86641]"> CNIL</a>
                (Commission Nationale de l'Informatique et des Libertés).
              </p>
            </Section>

            <Section title="7. Sécurité">
              <p>
                Nous mettons en œuvre des mesures techniques et organisationnelles pour garantir la sécurité de vos données :
                connexions chiffrées (HTTPS), mots de passe stockés sous forme chiffrée (bcrypt), accès restreint aux
                seules personnes autorisées.
              </p>
            </Section>

            <Section title="8. Cookies">
              <p>
                Le site utilise uniquement des <strong>cookies techniques strictement nécessaires</strong> au fonctionnement
                (cookies d'authentification de session). Ces cookies ne nécessitent pas de consentement préalable
                conformément à la position de la CNIL.
              </p>
              <p>
                Le site ne contient aucun cookie de mesure d'audience, publicitaire ou de réseaux sociaux.
              </p>
            </Section>

            <Section title="9. Modifications">
              <p>
                La présente politique de confidentialité peut être modifiée à tout moment. La date de dernière mise à jour
                figure en haut de la page. Nous vous invitons à la consulter régulièrement.
              </p>
            </Section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-2xl md:text-3xl tracking-tight text-[#1A1918] mb-4 border-l-2 border-[#C86641] pl-4">
        {title}
      </h2>
      <div className="space-y-3 text-[#5C5A56]">{children}</div>
    </section>
  );
}
